import type * as React from 'react';
import styled from 'styled-components';

import { Link } from '@xingternal/link';
import { scale150, spaceXXL, xdlColorTextSecondary } from '@xingternal/tokens';

import { useGeneratedLink } from './generate-link';

export const LegalFooterNavItem: React.FC<{
  title: string;
  href: string;
  tracking?: Record<string, string>;
}> = ({ title, href, tracking }) => {
  const link = useGeneratedLink(href, tracking);

  return (
    <Item>
      <Link to={link}>{title}</Link>
    </Item>
  );
};

const Item = styled.li`
  height: ${scale150};
  line-height: ${scale150};
  margin-right: ${spaceXXL};

  & a {
    color: ${xdlColorTextSecondary};
  }
`;
